import {useState} from 'react';
import DatePicker from "react-datepicker";



const DatePickerHook = (props) => {

  const [date, setDate] = useState("");
  const dropDownMode = props.selectDropdownMode ? "select" : "";

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    return currentDate.getTime() < selectedDate.getTime();
  };

  const updateGetDate = date => {
    props.getDate(date);
    setDate(date);
  }

  return (
    <DatePicker selected={props.selected ? props.selected : date}
									onChange={date => updateGetDate(date)}
									className={props.className}
									placeholderText={props.placeholder ? props.placeholder : "Select date"}
									dateFormat={props.dateFormat ? props.dateFormat : "dd/MM/yyyy"}
									timeFormat={props.timeFormat ? props.timeFormat : "HH:mm"}
									timeIntervals={props.timeIntervals ? props.timeIntervals : 10}
									showTimeSelect={props.showTimeSelect}
									showYearDropdown={props.showYearDropdown}
									dropdownMode={dropDownMode}
									minDate={props.setMinDate}
									maxDate={props.setMaxDate}
									withPortal={props.withPortal}
									filterTime={props.filterTime ? filterPassedTime : ""}
			/>
  );
}

export default DatePickerHook;